// ShipmentComponents/ShipmentHistoryCompact.jsx
import React from "react";
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent } from "@mui/lab";
import { Typography, Box } from "@mui/material";
import { useShipmentDetailContext } from "contexts/ShipmentDetailContext";
import { useAuth } from "hooks";

const ShipmentHistoryCompact = () => {
  const { getAuthorName } = useAuth();
  const { ShipmentDetail } = useShipmentDetailContext();
  const items = [...(ShipmentDetail?.history || [])].sort((a, b) => (a?.createdAt > b?.createdAt ? -1 : 1));
  const getAuthorTypeLabel = (createdBy) => ({ VendorProfile: "Vendor", VendorStaff: "Vendor Staff" }[createdBy?.typeRefSource] || "");

  return (
    <Box sx={{ p: 1 }}>
      <Timeline position="right" sx={{ p: 0, m: 0, "& .MuiTimelineItem-root::before": { flex: 0, padding: 0 } }}>
        {items.map((item, index) => (
          <TimelineItem key={item?._id || index}>
            <TimelineSeparator>
              <TimelineDot variant="outlined" sx={{ width: 14, height: 14 }}></TimelineDot>
              {index !== items.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ py: "4px", px: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Typography sx={{ fontSize: "0.64rem", fontWeight: 600, color: "text.secondary" }}>
                  {new Date(item?.createdAt).toLocaleString()}
                </Typography>
                <Typography sx={{ fontSize: "0.64rem", color: "text.disabled" }}>||</Typography>
                <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "primary.main" }}>
                  {item?.createdBy?.name || "Unknown"}
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "0.7rem", fontWeight: 600, mt: 0.5 }}>{item?.comment}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
};

export default ShipmentHistoryCompact;